export default "__VITE_ASSET__hYkYP1sd__"